import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiLoader from "../../components/MuiLoader";
import MuiHeader from "../../components/MuiHeader";
import { upload_file_to_s3, delete_file_from_s3 } from "../../components/S3";
// MUI
import {
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  TextField,
  Slide,
  Box,
  CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  save_image,
  update_image,
  get_image,
  delete_image,
} from "./DashboardSlider.thunk";

// Toastyfy
import { ToastContainer, toast } from "react-toastify";
import Modal from "@mui/material/Modal";

// swal
import Swal from "sweetalert2";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// ------------------ AWS S3 Configurations --------------------
import AWS from "aws-sdk";
import api from "../../api/api";
import { UploadFileToAzureDB, deleteFileFromDB } from "../../components/Azure";
const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const REGION = process.env.REACT_APP_REGION;
const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});
const S3 = new AWS.S3({
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

//~------------------------------For where to navigate-----------------------------
const navigationPageList = [
  { text: "None", value: "home" },
  { text: "Leaderboard", value: "leaderboard" },
  { text: "Profile", value: "profile" },
  { text: "Attendance", value: "attendanceList" },
  // { text: "Student Register", value: "studentregister" },
  // { text: "Student Register", value: "studentregister" },
  { text: "Rewards", value: "myachievement" },
  { text: "Community Engagement", value: "communityengagementpage" },
  { text: "Common Monthly Quiz", value: "commonmonthlypage" },
  { text: "FLN", value: "flncontent" },
];

//~------------------------------Usertypes list---------------------------------------
const usertype_select_option_list = [
  { value: "fellow", text: "Educator" },
  { value: "school", text: "School" },
  { value: "anganwadi", text: "Anganwadi" },
];
const mediatype_select_option_list = [
  { value: "image", text: "Image" },
  { value: "video", text: "Video" },
];

const DashboardSliderImage = () => {
  //~ -----------------------------------states----------------------------------
  const [usertype, setUsertype] = useState("fellow");
  const [mediatype, setMediatype] = useState("");
  console.log("mediatype", mediatype);
  const [showImageDialogModal, setShowImageDialogModal] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [imageContent, setImageContent] = useState([]);
  console.log("imageContent", imageContent);
  const dispatch = useDispatch();
  const inputFileRef = useRef();
  const [progress, setProgress] = useState("");
  const [updateExtra, setUpdateExtra] = useState([]);
  const [imgOrder, setImgOrder] = useState("");
  const [filename, setFilename] = useState("");
  const [loading, setLoading] = useState(false);
  const [navigationPage, setNavigationPage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState("");
  console.log("selectedImage", "imageName", selectedImage, imageName);
  const [fileExtensionType, setFileExtensionType] = useState("");
  const [file, setFile] = useState("");
  console.log("file", file);
  const [imgUrl, setImgUrl] = useState("");
  const [imgName, setImgName] = useState("");
  const [selectedVideo, setSelectedVideo] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const [youTubeLink, setYouTubeLink] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const { selectedQuestion } = useSelector(
    (state) => state.AudioAssessmentSlice
  );
  let imageUrl = "";
  const regex = /^[0-9\b]+$/;

  //*-----------------For selecting and displaying the image-----------------
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const maxHeight = 469;
    const maxWidth = 1063;
    const maxSize = 1048576; // 1MB

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (file.size > maxSize) {
        toast.error("File size exceeds the maximum allowed (1 MB)");
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = async () => {
          const { width, height } = img;

          if (width > maxWidth || height > maxHeight) {
            toast.error("Maximum height and width exceeded");
            return;
          }

          // Continue with your file extension/type validation
          if (fileExtension === "png" || fileType === "image/png") {
            setFileExtensionType("png");
            setImgName(`dboardSlider_${new Date().getTime()}.png`);
          } else if (
            fileExtension === "jpg" ||
            fileExtension === "jpeg" ||
            fileType === "image/jpeg"
          ) {
            setFileExtensionType("jpg");
            setImgName(`dboardSlider_${new Date().getTime()}.jpg`);
          } else {
            console.log("It is neither a PNG nor a JPG file.");
            return;
          }

          setSelectedImage(file);
          setFile(e.target.result);
        };
      };

      reader.readAsDataURL(file);
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 20971520; // 20MB
    const maxHeight = 469;
    const maxWidth = 1063;

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (file.size > maxSize) {
        toast.error("File size exceeds the maximum allowed (20 MB)");
        return;
      }

      if (fileExtension !== "mp4" || fileType !== "video/mp4") {
        toast.error("Please select a valid MP4 video file");
        return;
      }

      // Continue with your file validation
      const reader = new FileReader();

      reader.onload = (e) => {
        const video = document.createElement("video");
        video.src = e.target.result;

        video.onloadedmetadata = async () => {
          const { videoWidth, videoHeight } = video;

          if (videoWidth > maxWidth || videoHeight > maxHeight) {
            toast.error("Maximum height and width exceeded");
            return;
          }

          if (fileExtension === "mp4" || fileType === "video/mp4") {
            setFileExtensionType("mp4");
            setImgName(`dboardSlider_${new Date().getTime()}.mp4`);
          } else {
            console.log("It is not an MP4 file.");
            return;
          }
          // setSelectedImage(file);
          setFile(e.target.result);
        };
      };

      reader.readAsDataURL(file);
    }
  };

  //^----------------On navigation page change-----------------
  const changeNavigationPage = (e) => {
    setNavigationPage(e.target.value);
  };

  //^-------------------On usertype change-------------------
  const changeUsertype = (e) => {
    if (!e.target.value) {
      setUsertype("");
      setMediatype("");
      setImageContent([]);
    } else {
      setUsertype(e.target.value);
    }
  };

  const changeMediatype = (e) => {
    if (!e.target.value) {
      setMediatype("");
      setImageContent([]);
    } else {
      setImageContent("");
      setMediatype(e?.target?.value);
      if (e?.target?.value) {
        let data = { usertype: usertype, mediatype: e?.target?.value };
        setLoading(true);
        get_image(data)
          .then((res) => {
            console.log("res", res);
            if (res.status === 200) {
              setLoading(false);
              setImageContent(res.data);
            } else if (res.status === 204) {
              toast.info("There is no data !");
              setLoading(false);
            } else {
              setLoading(false);
            }
          })
          .catch((err) => {
            console.error("Error fetching image:", err);
            setLoading(false);
            toast.error("Failed to fetch image");
          });
      }
    }
  };

  //*----------------------------To show image dialog box------------------
  const open_create_image_dialog = () => {
    if (!mediatype) {
      toast.error("Please select usertype to proceed !");
    } else {
      setShowImageDialogModal(true);
    }
  };

  //*----------------------------To close image dialog box------------------
  const close_create_image_dialog = () => {
    setShowImageDialogModal(false);
  };

  // ^--------------- file actions -------------------
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [selectedFileSize, setSelectedFileSize] = useState(null);
  const [previewURL, setPreviewURL] = useState("");

  const close_image_dialog = () => {
    // reset();
    close_create_image_dialog();
    setShowImageDialogModal(false);
    setFile(null);
    setImageName("");
    setImgOrder("");
    setYouTubeLink("");
    setNavigationPage("");
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  //^---------------------Save function-------------------------------------
  const save_image_to_dashboard = () => {
    if (!selectedImage) {
      toast.error("Please select an Media before proceeding!");
    } else if (imageName.trim === "" || !imageName) {
      toast.error("Please add an Media name");
    } else if (!imgOrder) {
      toast.error("Please add a unique Media order!");
    } else if (mediatype === "image" && !navigationPage) {
      toast.error("Please select the screen for navigating !");
    } else {
      UploadFileToAzureDB(selectedImage, imgName);
      const body = {
        usertype: usertype,
        mediatype: mediatype,
        mediaId: new Date().getTime().toString(),
        mediaName: imageName.trim(),
        mediaUrl: youTubeLink ? youTubeLink : imgName,
        mediaOrder: parseInt(imgOrder),
        navigateTo: navigationPage,
      };
      setIsUpdating(true);
      save_image(body)
        .then((res) => {
          if (res.status === 201) {
            setIsUpdating(false);
            setLoading(true);
            const datum = { usertype: usertype, mediatype: mediatype };
            get_image(datum)
              .then((res) => {
                if (res.status === 200) {
                  close_create_image_dialog();
                  setImageContent(res.data);
                  setImgName("");
                  setSelectedImage(null);
                  setFile("");
                  setNavigationPage("");
                  setImageName("");
                  setSelectedFileType(null);
                  setSelectedFileSize(null);
                  setImgOrder("");
                  toast.success("Successfully added image !", {
                    style: {
                      backgroundColor: "green",
                      color: "white",
                      borderRadius: "30px",
                    },
                  });
                  const fileInput = document.getElementById("fileInput");
                  if (fileInput) {
                    fileInput.value = "";
                  }
                  setLoading(false);
                } else {
                  toast.error("Something went wrong in get_image !");
                }
              })
              .catch((error) => {
                console.error("Error in get_image:", error);
                toast.error("Error in get_image. Something went wrong !");
                const fileInput = document.getElementById("fileInput");
                if (fileInput) {
                  fileInput.value = "";
                }
              });
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 500) {
            toast.error(
              `Order ${parseInt(
                imgOrder
              )} already exists. Please choose a different order!`,
              {
                style: {
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "30px",
                },
              }
            );
          } else if (err.response && err.response.status === 504) {
            toast.error(
              `Order ${parseInt(
                imgOrder
              )} something went wrong. Please choose a different order!`,
              {
                style: {
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "30px",
                },
              }
            );
          } else if (err.response && err.response.status === 413) {
            toast.error("The file is too large to upload");
          } else {
            console.error(`Error in uploading part--->${err}`);
          }
        });
    }
  };

  // const save_video_to_dashboard = () => {
  //   if (!youTubeLink || youTubeLink.trim() === "") {
  //     toast.error("Please add a YouTube link!");
  //   } else if (imageName.trim === "" || !imageName) {
  //     toast.error("Please add an Media name");
  //   } else if (!imgOrder) {
  //     toast.error("Please add a unique Media order!");
  //   } else {
  //     // UploadFileToAzureDB(selectedImage, imgName);
  //     let body;
  //     if (youTubeLink.startsWith("https://youtu.be/")) {
  //       body = {
  //         usertype: usertype,
  //         mediatype: mediatype,
  //         mediaId: new Date().getTime().toString(),
  //         mediaName: imageName.trim(),
  //         mediaUrl: youTubeLink.split("/")[3].slice(0, 11),
  //         mediaOrder: parseInt(imgOrder),
  //         navigateTo: "",
  //       };
  //     } else if (youTubeLink.startsWith("https://www.youtube.com/watch?v=")) {
  //       body = {
  //         usertype: usertype,
  //         mediatype: mediatype,
  //         mediaId: new Date().getTime().toString(),
  //         mediaName: imageName.trim(),
  //         mediaUrl: youTubeLink
  //           .split("/")[3]
  //           .replace("watch?v=", "")
  //           .slice(0, 11),
  //         mediaOrder: parseInt(imgOrder),
  //         navigateTo: "",
  //       };
  //     } else {
  //       toast.error("Please add only YouTube link!");
  //       return;
  //     }
  //     setIsUpdating(true);
  //     save_image(body)
  //       .then((res) => {
  //         setIsUpdating(false);
  //         if (res.status === 201) {
  //           setLoading(true);
  //           const datum = { usertype: usertype, mediatype: mediatype };
  //           get_image(datum)
  //             .then((res) => {
  //               if (res.status === 200) {
  //                 close_create_image_dialog();
  //                 setImageContent(res.data);
  //                 setImgName("");
  //                 setSelectedImage(null);
  //                 setFile("");
  //                 setYouTubeLink("");
  //                 setNavigationPage("");
  //                 setImageName("");
  //                 setSelectedFileType(null);
  //                 setSelectedFileSize(null);
  //                 setImgOrder("");
  //                 toast.success("Successfully added media !");
  //                 const fileInput = document.getElementById("fileInput");
  //                 if (fileInput) {
  //                   fileInput.value = "";
  //                 }
  //                 setLoading(false);
  //               } else {
  //                 toast.error("Something went wrong in get_image !");
  //               }
  //             })
  //             .catch((error) => {
  //               console.error("Error in get_image:", error);
  //               toast.error("Error in get_image. Something went wrong !");
  //               const fileInput = document.getElementById("fileInput");
  //               if (fileInput) {
  //                 fileInput.value = "";
  //               }
  //             });
  //         }
  //       })
  //       .catch((err) => {
  //         toast.error(
  //           `Order ${parseInt(
  //             imgOrder
  //           )} already exists. Please choose a different order!`
  //         );
  //       });
  //   }
  // };
  const save_video_to_dashboard = () => {
    if (!youTubeLink || youTubeLink.trim() === "") {
      toast.error("Please add a YouTube link!");
    } else if (imageName.trim() === "" || !imageName) {
      toast.error("Please add a Media name");
    } else if (!imgOrder) {
      toast.error("Please add a unique Media order!");
    } else {
      let body;
      if (youTubeLink.startsWith("https://youtu.be/")) {
        body = {
          usertype: usertype,
          mediatype: mediatype,
          mediaId: new Date().getTime().toString(),
          mediaName: imageName.trim(),
          mediaUrl: youTubeLink.split("/")[3].slice(0, 11),
          mediaOrder: parseInt(imgOrder),
          navigateTo: "",
        };
      } else if (youTubeLink.startsWith("https://www.youtube.com/watch?v=")) {
        body = {
          usertype: usertype,
          mediatype: mediatype,
          mediaId: new Date().getTime().toString(),
          mediaName: imageName.trim(),
          mediaUrl: youTubeLink
            .split("/")[3]
            .replace("watch?v=", "")
            .slice(0, 11),
          mediaOrder: parseInt(imgOrder),
          navigateTo: "",
        };
      } else {
        toast.error("Please add only YouTube link!");
        return;
      }

      setIsUpdating(true);
      save_image(body)
        .then((res) => {
          setIsUpdating(false);
          if (res.status === 201) {
            setLoading(true);
            const datum = { usertype: usertype, mediatype: mediatype };
            get_image(datum)
              .then((res) => {
                if (res.status === 200) {
                  close_create_image_dialog();
                  setImageContent(res.data);
                  setImgName("");
                  setSelectedImage(null);
                  setFile("");
                  setYouTubeLink("");
                  setNavigationPage("");
                  setImageName("");
                  setSelectedFileType(null);
                  setSelectedFileSize(null);
                  setImgOrder("");
                  toast.success("Successfully added media!", {
                    style: {
                      backgroundColor: "green",
                      color: "white",
                      borderRadius: "30px",
                    },
                  });
                  const fileInput = document.getElementById("fileInput");
                  if (fileInput) {
                    fileInput.value = "";
                  }
                  setLoading(false);
                } else {
                  toast.error("Something went wrong in get_image!");
                }
              })
              .catch((error) => {
                console.error("Error in get_image:", error);
                toast.error("Error in get_image. Something went wrong!");
                const fileInput = document.getElementById("fileInput");
                if (fileInput) {
                  fileInput.value = "";
                }
              });
          }
        })
        .catch((error) => {
          setIsUpdating(false);
          if (error.response) {
            if (error.response.status === 500) {
              toast.error(
                `Order ${parseInt(
                  imgOrder
                )} already exists. Please choose a different order!`
              );
            } else if (error.response.status === 504) {
              toast.error("Gateway Timeout. Please try again later.");
            } else {
              console.error(`Error in save_image: ${error}`);
              toast.error("Something went wrong. Please try again.");
            }
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    }
  };

  //*----------------------------To update image with dialog box-----------
  const [updationValues, setUpdationValues] = useState([]);
  const [selectedImageAssesment, setSelectedImageAssesment] = useState({});
  const [updateData, setUpdateData] = useState({
    mediaName: "",
    mediaId: "",
    mediaUrl: "",
    mediaOrder: "",
    navigateTo: "",
    mediatype: "",
  });

  const [updateDataVideo, setUpdateDataVideo] = useState({});

  const edit_saved_image_dialog = (item) => {
    console.log("edit_saved_image_dialog", item);
    // const valueSentForUpdation = imageContent.filter(
    //   (obj) => obj.mediaId === item.mediaId
    // );
    // setUpdationValues(valueSentForUpdation);
    // setSelectedImageAssesment(item);
    setShowUpdate(true);
    if (item.mediatype === "image") {
      setUpdateData({
        mediaName: item?.mediaName,
        mediaId: item?.mediaId,
        mediatype: item?.mediatype,
        mediaUrl: item?.mediaUrl,
        mediaOrder: item?.mediaOrder,
        navigateTo: item?.navigateTo,
        usertype: item?.usertype,
      });
    } else {
      setUpdateData({
        mediaName: item?.mediaName,
        mediaId: item?.mediaId,
        mediatype: item?.mediatype,
        mediaUrl: `https://www.youtube.com/watch?v=${item.mediaUrl}`,
        mediaOrder: item?.mediaOrder,
        navigateTo: item?.navigateTo,
        usertype: item?.usertype,
      });
    }
  };

  const update_question = () => {
    if (mediatype === "image") {
      if (!imgName && !updateData.mediaUrl) {
        toast.error("Please select an media before proceeding!");
      } else if (updateData.mediaName.trim() === "" || !updateData.mediaName) {
        toast.error("Please add an media name");
      } else if (!updateData.mediaOrder) {
        toast.error("Please add a unique media order!");
      } else if (mediatype === "image" && !updateData?.navigateTo) {
        toast.error("Please select the screen for navigating !");
      } else {
        UploadFileToAzureDB(selectedImage, imgName);
        setIsUpdating(true);
        const body = {
          usertype: updateData.usertype,
          mediaName: updateData?.mediaName.trim(),
          mediaId: updateData?.mediaId,
          mediaUrl: file
            ? imgName
            : updateData.mediaUrl.split("/")[
                updateData.mediaUrl.split("/").length - 1
              ],
          mediaOrder: updateData?.mediaOrder,
          navigateTo: updateData?.navigateTo,
          mediatype: updateData?.mediatype,
        };
        update_image(body)
          .then((res) => {
            if (res.status === 200) {
              toast.success("Successfully updated !");
              setShowUpdate(false);
              setIsUpdating(false);
              const datum = { usertype: usertype, mediatype: mediatype };
              get_image(datum)
                .then((res) => {
                  if (res.status === 200) {
                    setImageContent(res.data);
                    setSelectedImage(null);
                    setFile("");
                    setImageName("");
                    setSelectedFileType(null);
                    setSelectedFileSize(null);
                  }
                })
                .catch((error) => {
                  console.error("Error in get_image:", error);
                  // toast.error("Error in get_image. Something went wrong !");
                });
            } else {
              toast.error("Sorry, something went wrong.");
            }
          })
          .catch((error) => {
            setIsUpdating(false);
            setShowUpdate(false);
            setUpdateData({
              mediaName: "",
              mediaId: "",
              mediaUrl: "",
              mediaOrder: "",
              navigateTo: "",
              mediatype: "",
            });
            if (error.response && error.response.status === 500) {
              toast.error(
                `Order ${parseInt(
                  imgOrder
                )} already exists. Please choose a different order!`
              );
            }
            if (error.response && error.response.status === 500) {
              toast.error(
                `Order ${parseInt(
                  imgOrder
                )} already exists. Please choose a different order!`
              );
            } else if (error.response && error.response.status === 504) {
              toast.error(
                `Order ${parseInt(
                  imgOrder
                )} something went wrong. Please choose a different order!`
              );
            } else if (error.response && error.response.status === 413) {
              toast.error("The file is too large to upload");
            } else {
              console.error(`Error in uploading part--->${error}`);
            }
          });
      }
    }
  };

  // const update_video = () => {
  //   if (!imgName && !updateData.mediaUrl) {
  //     toast.error("Please select an media before proceeding!");
  //   } else if (updateData.mediaName.trim() === "" || !updateData.mediaName) {
  //     toast.error("Please add an media name");
  //   } else if (!updateData.mediaOrder) {
  //     toast.error("Please add a unique media order!");
  //   } else if (mediatype === "image" && !updateData?.navigateTo) {
  //     toast.error("Please select the screen for navigating !");
  //   } else {
  //     let body;

  //     if (updateData.mediaUrl.startsWith("https://youtu.be/")) {
  //       body = {
  //         usertype: updateData.usertype,
  //         mediatype: updateData.mediatype,
  //         mediaId: updateData?.mediaId,
  //         mediaName: updateData?.mediaName.trim(),
  //         mediaUrl: updateData.mediaUrl.split("/")[3],
  //         mediaOrder: updateData?.mediaOrder,
  //         navigateTo: "",
  //       };
  //     } else if (
  //       updateData.mediaUrl.startsWith("https://www.youtube.com/watch?v=")
  //     ) {
  //       body = {
  //         usertype: updateData.usertype,
  //         mediatype: updateData.mediatype,
  //         mediaId: updateData?.mediaId,
  //         mediaName: updateData?.mediaName.trim(),
  //         mediaUrl: updateData.mediaUrl
  //           .split("/")[3]
  //           .replace("watch?v=", "")
  //           .slice(0, 11),
  //         mediaOrder: updateData?.mediaOrder,
  //         navigateTo: "",
  //       };
  //     } else {
  //       toast.error("Please add only YouTube link!");
  //       return;
  //     }
  //     setIsUpdating(true);
  //     update_image(body)
  //       .then((res) => {
  //         if (res.status === 200) {
  //           toast.success("Successfully updated !");
  //           setShowUpdate(false);
  //           setIsUpdating(false);
  //           const datum = { usertype: usertype, mediatype: mediatype };
  //           get_image(datum)
  //             .then((res) => {
  //               if (res.status === 200) {
  //                 setImageContent(res.data);
  //                 setSelectedImage(null);
  //                 setFile("");
  //                 setImageName("");
  //                 setSelectedFileType(null);
  //                 setSelectedFileSize(null);
  //               }
  //             })
  //             .catch((error) => {
  //               console.error("Error in get_image:", error);
  //               toast.error("Error in get_image. Something went wrong !");
  //             });
  //         } else {
  //           toast.error("Sorry, something  went wrong.");
  //         }
  //       })
  //       .catch((error) => {
  //         setIsUpdating(false);
  //         setShowUpdate(false);
  //         setUpdateData({
  //           mediaName: "",
  //           mediaId: "",
  //           mediaUrl: "",
  //           mediaOrder: "",
  //           navigateTo: "",
  //           mediatype: "",
  //         });
  //         console.error("Error in update_image:", error);
  //         toast.error(
  //           `Order ${updateData?.mediaOrder} already exists. Please choose a unique order!`
  //         );
  //       });
  //   }
  // };

  const update_video = () => {
    if (!imgName && !updateData.mediaUrl) {
      toast.error("Please select a media before proceeding!");
    } else if (updateData.mediaName.trim() === "" || !updateData.mediaName) {
      toast.error("Please add a media name");
    } else if (!updateData.mediaOrder) {
      toast.error("Please add a unique media order!");
    } else if (mediatype === "image" && !updateData?.navigateTo) {
      toast.error("Please select the screen for navigating!");
    } else {
      let body;

      if (updateData.mediaUrl.startsWith("https://youtu.be/")) {
        body = {
          usertype: updateData.usertype,
          mediatype: updateData.mediatype,
          mediaId: updateData?.mediaId,
          mediaName: updateData?.mediaName.trim(),
          mediaUrl: updateData.mediaUrl.split("/")[3],
          mediaOrder: updateData?.mediaOrder,
          navigateTo: "",
        };
      } else if (
        updateData.mediaUrl.startsWith("https://www.youtube.com/watch?v=")
      ) {
        body = {
          usertype: updateData.usertype,
          mediatype: updateData.mediatype,
          mediaId: updateData?.mediaId,
          mediaName: updateData?.mediaName.trim(),
          mediaUrl: updateData.mediaUrl
            .split("/")[3]
            .replace("watch?v=", "")
            .slice(0, 11),
          mediaOrder: updateData?.mediaOrder,
          navigateTo: "",
        };
      } else {
        toast.error("Please add only YouTube link!");
        return;
      }
      setIsUpdating(true);
      update_image(body)
        .then((res) => {
          if (res.status === 200) {
            toast.success("Successfully updated !", {
              style: {
                backgroundColor: "green",
                color: "white",
                borderRadius: "30px",
              },
            });
            setShowUpdate(false);
            setIsUpdating(false);
            const datum = { usertype: usertype, mediatype: mediatype };
            get_image(datum)
              .then((res) => {
                if (res.status === 200) {
                  setImageContent(res.data);
                  setSelectedImage(null);
                  setFile("");
                  setImageName("");
                  setSelectedFileType(null);
                  setSelectedFileSize(null);
                } else if (res.status === 204) {
                  toast.info("No Data!", {
                    style: {
                      backgroundColor: "blue",
                      color: "white",
                      borderRadius: "30px",
                    },
                  });
                } else {
                  toast.error("Sorry, something went wrong!", {
                    style: {
                      backgroundColor: "red",
                      color: "white",
                      borderRadius: "30px",
                    },
                  });
                }
              })
              .catch((error) => {
                console.error("Error in get_image:", error);
                toast.error("Error in get_image. Something went wrong!", {
                  style: {
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "30px",
                  },
                });
              });
          } else {
            toast.error("Sorry, something went wrong.", {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            });
          }
        })
        .catch((error) => {
          setIsUpdating(false);
          setShowUpdate(false);
          setUpdateData({
            mediaName: "",
            mediaId: "",
            mediaUrl: "",
            mediaOrder: "",
            navigateTo: "",
            mediatype: "",
          });

          if (error.response) {
            if (error.response.status === 500) {
              toast.error("Internal Server Error. Please try again later.", {
                style: {
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "30px",
                },
              });
            } else if (error.response.status === 504) {
              toast.error("Gateway Timeout. Please try again later.", {
                style: {
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "30px",
                },
              });
            } else {
              toast.error(
                `Error: ${error.response.status}. Please try again later.`,
                {
                  style: {
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "30px",
                  },
                }
              );
            }
          } else {
            toast.error(
              "An unexpected error occurred. Please try again later.",
              {
                style: {
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "30px",
                },
              }
            );
            console.error("Error in update_image:", error);
          }
        });
    }
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
    // setUpdateData({
    //   mediaName: "",
    //   mediaId: "",
    //   mediaUrl: "",
    //   mediaOrder: "",
    //   navigateTo: "",
    //   mediatype: "",
    // });
    setImgName("");
    setSelectedImage(null);
    setFile("");
    setSelectedFileType(null);
    setSelectedFileSize(null);
  };

  useEffect(() => {
    // Update updateData when updationValues change
    if (updationValues && updationValues.length > 0) {
      const { mediaName, mediaId, mediaUrl, mediaOrder, navigateTo } =
        updationValues[0];
      setUpdateData({
        mediaName: mediaName,
        mediaId: mediaId,
        mediaUrl: mediaUrl,
        mediaOrder: mediaOrder,
        navigateTo: navigateTo,
        mediatype: mediatype,
      });
    }
  }, [updationValues]);

  const isImageFormat = (fileType) => {
    const acceptedFormats = ["image/png", "image/gif", "image/jpeg"];
    return acceptedFormats.includes(fileType);
  };

  const deleteImageForUpdate = (item) => {
    deleteFileFromDB(item?.mediaUrl);
    toast.error("Successfully removed media !");
    setUpdateData({ ...updateData, mediaUrl: "" });
  };

  const delete_image_box = (item) => {
    console.log("delete_image_box", item);

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this image?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFileFromDB(item?.mediaUrl);
        setIsDeleting(true);

        delete_image(item?.mediaId)
          .then((res) => {
            if (res.status === 200) {
              setIsDeleting(false);
              toast.success("Successfully deleted", {
                style: {
                  backgroundColor: "green",
                  color: "white",
                  borderRadius: "30px",
                },
              });

              const data = {
                usertype,
                mediatype,
              };

              setLoading(true);
              get_image(data)
                .then((res) => {
                  if (res.status === 200) {
                    setImageContent(res.data);
                    setLoading(false);
                  } else if (res.status === 204) {
                    toast.info("No Data!", {
                      style: {
                        backgroundColor: "blue",
                        color: "white",
                        borderRadius: "30px",
                      },
                    });
                    setLoading(false);
                  } else {
                    toast.error("Sorry, something went wrong!", {
                      style: {
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "30px",
                      },
                    });
                    setLoading(false);
                  }
                })
                .catch((err) => {
                  handleError(err);
                  setLoading(false);
                });
            } else {
              handleError(res);
            }
          })
          .catch((err) => {
            handleError(err);
            setIsDeleting(false);
          });
      }
    });
  };

  const handleError = (err) => {
    if (err.response) {
      if (err.response.status === 500) {
        toast.error("Internal Server Error. Please try again later.", {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
      } else if (err.response.status === 504) {
        toast.error("Gateway Timeout. Please try again later.", {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
      } else {
        toast.error(`Error: ${err.response.status}. Please try again later.`, {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
      }
    } else {
      toast.error("An unexpected error occurred. Please try again later.", {
        style: {
          backgroundColor: "red",
          color: "white",
          borderRadius: "30px",
        },
      });
      console.error(`Error: ${err}`);
    }
  };

  const reset = () => {
    setMediatype("");
    setImgName("");
    setSelectedImage(null);
    setFile("");
    setImageName("");
    setYouTubeLink("");
    setSelectedFileType(null);
    setSelectedFileSize(null);
    setImgOrder("");
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  //TODO------------------------------Console logs-----------------------------
  // console.log("imgName--------------------------->", imgName);
  // console.log("selectedImage--------------------------->", selectedImage);
  // console.log("imageName--------------------------->", imageName);
  console.log("updateData------------------------------>", updateData);
  // console.log("imageContent------------------------------->", imageContent);
  // console.log(
  //   `  updateData.mediaName: ${updateData.mediaName}     updateData.imgOrder:${updateData.mediaOrder}   updateData.navigateTo:${updateData.navigateTo}`
  // );
  // console.log("youTubeLink--------------------------->", youTubeLink);
  console.log(`updateData.mediaUrl : ${updateData.mediaUrl}`);
  // console.log("file--------------------------->", file);

  return (
    <>
      <div>
        <MuiHeader header="Dashboard Slider" />

        <FormControl
          sx={{ marginTop: 4, width: 160, marginLeft: 2 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Usertype"
            onChange={changeUsertype}
          >
            <MenuItem value={null}>None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{ marginTop: 4, width: 160, marginLeft: 2 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Mediatype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={mediatype}
            label="Media type"
            onChange={changeMediatype}
          >
            <MenuItem value={null}>None</MenuItem>
            {usertype && usertype.length > 0
              ? mediatype_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
        {mediatype ? (
          <Button
            variant="outlined"
            onClick={open_create_image_dialog}
            style={{ marginTop: "36px" }}
          >
            Add Media
          </Button>
        ) : null}
      </div>

      <div style={{ marginTop: "55px" }}>
        <Grid container spacing={2}>
          {mediatype !== "" && imageContent?.length > 0
            ? imageContent.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <Card
                    key={index}
                    sx={{
                      width: "100%",
                      height: "100%",
                      // marginBottom: 4,
                      backgroundColor: "#E0E0E0",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {mediatype === "image" ? (
                      <>
                        {!imageLoaded && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              // height: 194,
                              backgroundColor: "#F5F5F5",
                            }}
                          >
                            Loading...
                          </div>
                        )}
                        <img
                          style={{
                            display: imageLoaded ? "block" : "none",
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                          src={item?.mediaUrl}
                          alt={item?.mediaId}
                          onLoad={() => setImageLoaded(true)}
                        />
                      </>
                    ) : mediatype === "video" ? (
                      <>
                        <iframe
                          title="YouTube Video"
                          width="100%"
                          height="195"
                          src={`https://www.youtube.com/embed/${item?.mediaUrl}`}
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </>
                    ) : null}
                    <div
                      style={{
                        padding: "13px",
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "15px",
                        color: "#3A3B3C",
                        flexWrap: "wrap",
                      }}
                    >
                      {item?.navigateTo && item?.navigateTo?.length > 0 && (
                        <div
                          style={{
                            marginRight: "10px",
                            fontWeight: 500,
                            flexBasis: "100%",
                            marginBottom: "10px",
                          }}
                        >
                          Screen: {item?.navigateTo}
                        </div>
                      )}
                      {item?.mediaName && (
                        <div
                          style={{
                            marginRight: "10px",
                            fontWeight: 500,
                            flexBasis: "100%",
                            marginBottom: "10px",
                          }}
                        >
                          Name: {item?.mediaName}
                        </div>
                      )}
                      {item?.mediaOrder && (
                        <div
                          style={{
                            fontWeight: 500,
                            flexBasis: "100%",
                            marginBottom: "10px",
                          }}
                        >
                          Order: {item?.mediaOrder}
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        backgroundColor: "#D8D8D8",
                      }}
                    >
                      <Button onClick={() => edit_saved_image_dialog(item)}>
                        <EditIcon />
                      </Button>
                      <Button
                        sx={{ color: "red" }}
                        onClick={() => delete_image_box(item)}
                      >
                        {isDeleting ? (
                          <CircularProgress size={24} />
                        ) : (
                          <DeleteIcon />
                        )}
                      </Button>
                    </div>
                  </Card>
                </Grid>
              ))
            : null}
        </Grid>
      </div>
      <Dialog
        open={showImageDialogModal}
        TransitionComponent={Transition}
        keepMounted
        // onClose={close_create_image_dialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle style={{}}>DASHBOARD MEDIA BOX</DialogTitle>
        <DialogContent>
          {/* {progress > 0 && <div>Upload Progress: {progress}%</div>} */}
          <div style={{ marginTop: "8px" }}>
            <TextField
              id="outlined-basic"
              label="media Name"
              variant="outlined"
              sx={{ height: "50px", width: "100%" }}
              value={imageName}
              onChange={(e) => setImageName(e.target.value)}
            />
          </div>
          <div style={{ marginTop: "15px" }}>
            <TextField
              type="number"
              variant="outlined"
              value={imgOrder}
              onChange={(e) => {
                if (e.target.value === "" || regex.test(e.target.value)) {
                  setImgOrder(e.target.value);
                }
              }}
              id="outlined-multiline-flexible"
              label="Order"
              maxRows={2}
              sx={{ height: "50px", width: "100%" }}
            />
          </div>
          {mediatype === "image" ? (
            <div style={{ marginTop: "20px" }}>
              <FormControl sx={{ minWidth: "100%" }} size="small">
                <InputLabel id="demo-select-small">Screen Name</InputLabel>
                <Select
                  style={{ width: "100%", height: "50px" }}
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={navigationPage}
                  label="Screen Name"
                  onChange={changeNavigationPage}
                >
                  {navigationPageList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          ) : null}

          {/* <div style={{ marginTop: "10px" }}>
            <input
              type={mediatype === "image" ? "file" : "video"}
              accept={mediatype === "image" ? "image/*" : "video/*"}
              onChange={
                mediatype === "image" ? handleImageChange : handleVideoChange
              }
              id="fileInput"
            />
            {file && (
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {mediatype === "image" ? (
                  <img
                    src={file}
                    alt="Selected"
                    style={{ maxWidth: "100%", marginTop: "10px" }}
                  />
                ) : (
                  <video
                    controls
                    src={file}
                    style={{ maxWidth: "100%", marginTop: "10px" }}
                  />
                )}
              </div>
            )}
          </div> */}
          {mediatype === "image" ? (
            <div style={{ marginTop: "10px" }}>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                id="fileInput"
              />
              {file && (
                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                  <img
                    src={file}
                    alt="Selected"
                    style={{ maxWidth: "100%", marginTop: "10px" }}
                  />
                </div>
              )}
            </div>
          ) : (
            <div style={{ marginTop: "10px" }}>
              {/* <>
                <input
                  type="file"
                  accept="video/*"
                  onChange={handleVideoChange}
                  id="fileInput"
                />
                {file && (
                  <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                    {mediatype === "image" ? (
                      <img
                        src={file}
                        alt="Selected"
                        style={{ maxWidth: "100%", marginTop: "10px" }}
                      />
                    ) : (
                      <video
                        src={file}
                        alt="video"
                        controls
                        style={{ maxWidth: "100%", marginTop: "10px" }}
                      />
                    )}
                  </div>
                )}
              </> */}
              <>
                <TextField
                  id="linkUrl"
                  label="URL"
                  name="linkUrl"
                  size="small"
                  autoComplete="url"
                  margin="normal"
                  required
                  fullWidth
                  value={youTubeLink}
                  onChange={(e) => {
                    const url = e.target.value;
                    if (url.startsWith("https://www.youtube.com/watch?v=")) {
                      const videoId = url.split("v=")[1].slice(0, 11);
                      console.log(
                        "videoId----------------------------<>",
                        videoId
                      );
                      setYouTubeLink(`https://youtu.be/${videoId}`);
                    } else {
                      setYouTubeLink(url);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      e.preventDefault();
                    }
                  }}
                />
                {youTubeLink && youTubeLink.startsWith("https://youtu.be/") && (
                  <iframe
                    title="YouTube Video"
                    width="300"
                    height="195"
                    src={`https://www.youtube.com/embed/${youTubeLink
                      .split("/")[3]
                      .slice(0, 11)}`}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                )}
              </>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={close_image_dialog}>Cancel</Button>
          {mediatype === "image" ? (
            <Button
              onClick={save_image_to_dashboard}
              disabled={
                imageName.trim().length > 0 &&
                navigationPage &&
                imgOrder &&
                selectedImage
                  ? false
                  : true
              }
            >
              {isUpdating ? <CircularProgress size={24} /> : "Save"}
            </Button>
          ) : (
            <Button
              // onClick={save_image_to_dashboard}
              onClick={save_video_to_dashboard}
              disabled={
                imageName.trim().length > 0 &&
                imgOrder &&
                // selectedImage
                //   ? false
                //   : true
                youTubeLink
                  ? false
                  : true
              }
            >
              {isUpdating ? <CircularProgress size={24} /> : "Save"}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={showUpdate}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleCloseUpdate}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle style={{ marginLeft: "23px" }}>
          Dashboard media Box
        </DialogTitle>
        <DialogContent>
          {/* {progress > 0 && progress !== 100 && (
            <div>Upload Progress: {progress}%</div>
          )} */}
          <div style={{ marginTop: "8px" }}>
            <TextField
              id="outlined-basic"
              label="Media Name"
              variant="outlined"
              sx={{ height: "50px", width: "100%" }}
              value={updateData?.mediaName}
              onChange={(e) =>
                setUpdateData({
                  ...updateData,
                  mediaName: e.target.value,
                })
              }
            />
          </div>
          <div style={{ marginTop: "15px" }}>
            <TextField
              type="number"
              variant="outlined"
              value={updateData?.mediaOrder}
              onChange={(e) => {
                setUpdateData({
                  ...updateData,
                  mediaOrder: e.target.value,
                });
              }}
              id="outlined-multiline-flexible"
              label="Order"
              maxRows={2}
              sx={{ height: "50px", width: "100%" }}
            />
          </div>
          {mediatype === "image" ? (
            <div style={{ marginTop: "20px" }}>
              <FormControl sx={{ minWidth: "100%" }} size="small">
                <InputLabel id="demo-select-small">Screen Name</InputLabel>
                <Select
                  style={{ width: "100%", height: "50px" }}
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={updateData?.navigateTo}
                  label="Screen Name"
                  onChange={(e) => {
                    setUpdateData({
                      ...updateData,
                      navigateTo: e.target.value,
                    });
                  }}
                >
                  {/* <MenuItem value={null}>None</MenuItem> */}
                  {navigationPageList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          ) : null}

          <div style={{ marginTop: "10px" }}>
            {updateData.mediaUrl && mediatype == "image" ? (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "red",
                  marginLeft: "20px",
                  marginTop: "120px",
                }}
                onClick={() => deleteImageForUpdate(updateData)}
              >
                Remove media
              </Button>
            ) : mediatype === "image" ? (
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
            ) : null}

            <div style={{ maxHeight: "300px", overflowY: "hidden" }}>
              {(mediatype === "image" && updateData.mediaUrl) ||
              (mediatype === "image" && file) ? (
                <img
                  src={
                    file ? file : updateData.mediaUrl ? updateData.mediaUrl : ""
                  }
                  alt="Image"
                  style={{ maxWidth: "100%", marginTop: "10px" }}
                />
              ) : mediatype === "video" ? (
                <>
                  <TextField
                    id="linkUrl"
                    label="URL"
                    name="linkUrl"
                    size="small"
                    autoComplete="url"
                    margin="normal"
                    required
                    fullWidth
                    value={updateData.mediaUrl}
                    onChange={(e) => {
                      const url = e.target.value;
                      console.log("url-------------------->", url);
                      let videoId = "";
                      if (url.startsWith("https://www.youtube.com/watch?v=")) {
                        videoId = url.split("v=")[1].slice(0, 11);
                        setUpdateData({
                          ...updateData,
                          mediaUrl: `https://www.youtube.com/watch?v=${videoId}`,
                        });
                      } else if (url.startsWith("https://youtu.be/")) {
                        videoId = url.split("/").pop().split("?")[0];
                        setUpdateData({
                          ...updateData,
                          mediaUrl: `https://youtu.be/${videoId}`,
                        });
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                  {updateData.mediaUrl ? (
                    <iframe
                      title="YouTube Video"
                      width="300"
                      height="195"
                      src={
                        updateData?.mediaUrl.startsWith(
                          "https://www.youtube.com/watch?v="
                        )
                          ? `https://www.youtube.com/embed/${updateData?.mediaUrl
                              ?.split("/")[3]
                              .replace("watch?v=", "")
                              .slice(0, 11)}`
                          : updateData?.mediaUrl.startsWith("https://youtu.be/")
                          ? `https://www.youtube.com/embed/${
                              updateData?.mediaUrl?.split("/")[3]
                            }`
                          : null
                      }
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseUpdate}
            disabled={updateData.mediaUrl ? false : file ? false : true}
          >
            Cancel
          </Button>
          {mediatype === "image" ? (
            <Button
              onClick={update_question}
              disabled={
                updateData.mediaName &&
                updateData.mediaOrder &&
                updateData.navigateTo &&
                updateData.mediaUrl
                  ? false
                  : updateData.mediaName &&
                    updateData.mediaOrder &&
                    updateData.navigateTo &&
                    file
                  ? false
                  : true
              }
            >
              {isUpdating ? <CircularProgress size={24} /> : "Update"}
            </Button>
          ) : (
            <Button
              onClick={update_video}
              disabled={
                updateData.mediaName &&
                updateData.mediaOrder &&
                updateData.mediaUrl
                  ? false
                  : true
              }
            >
              {isUpdating ? <CircularProgress size={24} /> : "Update"}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Toaster */}
      <ToastContainer />

      {/* Loader */}
      <MuiLoader open={loading} />
    </>
  );
};

export default DashboardSliderImage;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
